import { AxiosResponse } from 'axios';
import { apiCall, clearCachedGetRequests } from './BaseAction';
import {
  ChemicalImageUpload,
  FilterChemicalsList,
  GetChemicalList,
  GetChemicalProduct,
  TFilterChemicalsListAction,
  TGetChemicalListAction,
  TGetChemicalProductAction,
  TUploadChemicalImage,
} from '../types/Chemical';
import { TApiEntityImage } from '../types/Equipment';
import { Dispatch } from 'redux';
import { TDispatch } from '../types/Thunk';

export const getChemicalsList = () => {
  return apiCall<TGetChemicalListAction, null>(
    GetChemicalList,
    'GET',
    '/chemical/products',
    true
  );
};

export const getChemicalProduct = (productId: number) => {
  return apiCall<TGetChemicalProductAction, null>(
    GetChemicalProduct,
    'GET',
    `/chemical/product/${productId}`,
    true
  );
};

export const uploadChemicalImage = (productId: number, image: string) => {
  return async (
    dispatch: TDispatch<TUploadChemicalImage>
  ): Promise<AxiosResponse<TApiEntityImage>> => {
    const response = await apiCall<
      TUploadChemicalImage,
      { image: string },
      TApiEntityImage
    >(
      ChemicalImageUpload,
      'POST',
      `/chemical/product/${productId}/image`,
      true,
      { image }
    )(dispatch);

    await clearCachedGetRequests();

    return response;
  };
};

export const filterChemicalsList = (search: string, location: string) => {
  return (dispatch: Dispatch<TFilterChemicalsListAction>) => {
    dispatch({
      type: FilterChemicalsList.SUBMIT,
      payload: {
        search,
        location,
      },
    });
  };
};
